(() => {
  const sliders = document.querySelectorAll('[data-dryon-slider]');
  sliders.forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-dryon-slide]')];
    const buttons = [...slider.querySelectorAll('[data-dryon-slide-button]')];
    let current = 0;

    const show = (index) => {
      current = index;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', String(active));
      });
    };

    buttons.forEach((button) => button.addEventListener('click', () => show(Number(button.dataset.dryonSlideButton))));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(() => show((current + 1) % slides.length), 6000);
    }
  });

  document.querySelectorAll('[data-dryon-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-dryon-main-image]');
    gallery.querySelectorAll('[data-dryon-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumbnail.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        gallery.querySelectorAll('[data-dryon-thumbnail]').forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      });
    });
  });

  const productAssetMap = window.EVERSTAY_PRODUCT_ASSETS || {};
  const productHandlePattern = /\/products\/([^/?#]+)/;

  const setImageSource = (image, src) => {
    if (!image || !src) return;
    image.src = src;
    image.srcset = '';
    image.dataset.src = src;
    image.dataset.srcset = '';
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
  };

  const getHandleFromUrl = (url) => {
    const match = String(url || '').match(productHandlePattern);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const replaceCardMedia = () => {
    document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      if (link.closest('.dryon-hero, .dryon-story, .dryon-mission')) return;
      const handle = getHandleFromUrl(link.getAttribute('href'));
      const assets = productAssetMap[handle];
      if (!assets?.length) return;

      const card = link.closest('.dryon-card, .card-wrapper, product-component, .product-card-wrapper') || link;
      const images = [...card.querySelectorAll('img')];
      images.forEach((image, index) => setImageSource(image, assets[Math.min(index, assets.length - 1)]));
    });
  };

  const replaceProductPageMedia = () => {
    const handle = getHandleFromUrl(window.location.pathname);
    const assets = productAssetMap[handle];
    if (!assets?.length) return;

    const galleryImages = [
      ...document.querySelectorAll('.product__media-wrapper img, .product-media-modal img, .thumbnail-list img'),
    ];
    galleryImages.forEach((image, index) => setImageSource(image, assets[index % assets.length]));
  };

  replaceCardMedia();
  replaceProductPageMedia();
  window.addEventListener('load', () => {
    replaceCardMedia();
    replaceProductPageMedia();
  });

  const productMediaObserver = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
    replaceCardMedia();
  });
  productMediaObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.querySelectorAll('.dryon-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('[aria-live]');
      if (button) button.disabled = true;
      if (status) status.textContent = 'Adding to cart…';

      try {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
        if (status) status.textContent = 'Added to cart.';
        window.location.assign(window.routes.cart_url);
      } catch (error) {
        if (status) status.textContent = error.message;
        if (button) button.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-dryon-bundle]').forEach((bundle) => {
    const options = [...bundle.querySelectorAll('[data-dryon-bundle-option]')];
    const productInfo = bundle.closest('product-info');
    const stickyQuantity = document.querySelector('[data-dryon-sticky-quantity]');

    const applyOption = (option) => {
      const quantity = Math.max(1, Number(option.dataset.quantity) || 1);

      options.forEach((item) => {
        item.closest('.dryon-bundle-option')?.classList.toggle('is-selected', item === option);
      });

      productInfo?.querySelectorAll('input[name="quantity"]').forEach((input) => {
        input.value = String(quantity);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (stickyQuantity) stickyQuantity.value = String(quantity);
    };

    options.forEach((option) => option.addEventListener('change', () => applyOption(option)));
    const selectedOption = options.find((option) => option.checked) || options[0];
    if (selectedOption) applyOption(selectedOption);
  });

  document.querySelectorAll('[data-dryon-product-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[data-dryon-product-tab]')];
    const panels = [...tabs.querySelectorAll('[data-dryon-product-panel]')];

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.dryonProductTab;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.dryonProductPanel !== target;
        });
      });
    });
  });

  document.querySelectorAll('[data-dryon-review-carousel]').forEach((carousel) => {
    const cards = [...carousel.querySelectorAll('.dryon-review-card')];
    if (!cards.length) return;

    let reviewFrame;
    let scrollAmount = carousel.scrollLeft;

    const setActiveReview = () => {
      const center = window.innerWidth / 2;
      let closestCard = cards[0];
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card) => {
        const box = card.getBoundingClientRect();
        const distance = Math.abs(box.left + box.width / 2 - center);
        if (distance < closestDistance) {
          closestCard = card;
          closestDistance = distance;
        }
      });

      cards.forEach((card) => card.classList.toggle('is-active', card === closestCard));
    };

    const scheduleActiveReview = () => {
      window.cancelAnimationFrame(reviewFrame);
      reviewFrame = window.requestAnimationFrame(setActiveReview);
    };

    const advanceReviews = () => {
      scrollAmount += 200;
      if (scrollAmount >= carousel.scrollWidth - carousel.clientWidth) scrollAmount = 0;
      carousel.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    };

    carousel.addEventListener('scroll', scheduleActiveReview, { passive: true });
    window.addEventListener('resize', scheduleActiveReview);
    setActiveReview();

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(advanceReviews, 3000);
    }
  });

  document.querySelectorAll('[data-dryon-sticky-cart]').forEach((stickyCart) => {
    const quantityInput = stickyCart.querySelector('[data-dryon-sticky-quantity]');
    const decreaseButton = stickyCart.querySelector('[data-dryon-sticky-decrease]');
    const increaseButton = stickyCart.querySelector('[data-dryon-sticky-increase]');
    const mainAddButton = document.querySelector('product-info .product-form__submit');

    const updateQuantity = (change) => {
      if (!quantityInput) return;
      const nextValue = Math.max(1, Number(quantityInput.value || 1) + change);
      quantityInput.value = String(nextValue);
    };

    decreaseButton?.addEventListener('click', () => updateQuantity(-1));
    increaseButton?.addEventListener('click', () => updateQuantity(1));

    let scheduled = false;
    const updateStickyVisibility = () => {
      scheduled = false;
      if (!mainAddButton) return;
      stickyCart.classList.toggle('is-visible', mainAddButton.getBoundingClientRect().bottom < 0);
    };

    const scheduleVisibilityUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateStickyVisibility);
    };

    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleVisibilityUpdate);
    updateStickyVisibility();
  });
})();
